import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import RadioGroup from '../../SidePanel/RightPanel/PropertiesControllerRadioGroup.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
import Model from './ModelOpr.mjs'
import OprType from './OprType.jsx'

const oprTypeOptions = OprType.map(
    ([value, label, icon]) => ({icon, label, value})
)

const PropertiesPaneOpr = (props) => (
    <ComponentPropertiesPane
        controllers={
            <>
                <LongText prop="oprTitle" />

                <RadioGroup
                    options={oprTypeOptions}
                    prop="oprType"
                />
            </>
        }

        Model={Model}
        noSn

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneOpr
